exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#infoFrom .el-form-item{margin-bottom:10px}#infoFrom label{font-size:14px;color:hsla(0,0%,61%,.6)}.classCenterInfo{min-height:160px}#centerDiv span{font-size:16px;color:#868585;display:inline-block}#centerDiv button span{color:#fff}#centerDiv label{font-size:14px;color:hsla(0,0%,61%,.6)}#centerDiv .kuorong{margin-left:10px;padding:2px 12px;background-color:#d5e7ff;border:1px solid #d5e7ff;border-radius:10px}#centerDiv .kuorong span{font-size:12px;color:#2f87ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2ab4986","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/js/pages/exam/TeacherCenter.vue
// module id = 813
// module chunks = 9